import { render, staticRenderFns } from "./StoreResearchSettings.vue?vue&type=template&id=a7c42094&"
import script from "./StoreResearchSettings.vue?vue&type=script&lang=js&"
export * from "./StoreResearchSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports